<template>
  <div>
    <CRow>
      <CCol md="12" lg="12" xl="12" xxl="12" xs="12" sm="12">
        <CTableWrapper
          :items="data"
          :fields="fields"
          hover
          :striped="true"
          :border="true"
          small
          fixed
          caption="Lista de tipo de campos"
          icon="fas fa-coins"
          btn_name="Tipo de campo"
          @mtdBack="mtdBack"
          @show_modal="mtd_open_modal"
          @action_edit="mtd_show"
          @action_delete="mtd_delete"
          :size="'md'"
          :button_new="this.$store.getters.get__user_id == 1? true : false"
          :actions="this.$store.getters.get__user_id == 1? true : false"
          :withActions="'2%'"
          :buttonEdit="true"
          :buttonDelete="true"
        />
      </CCol>
    </CRow>

    <!-- modal -->
    <CModalForm
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="modal.title"
      :button="cp_button"
      :show.sync="modal.modal_form"
      @mtd_action="mtd_action"
      :color="'info'"
      :centered="true"
    >
      <CRow>
        <CCol sm="12">
          <CInput
            label="Nombre"
            placeholder="Digite nombre"
            v-model="type_of_field.name"
          />
        </CCol>
        <CCol v-if="modal.action != 'store'" sm="12">
          <label for="">Estado</label>
          <CSwitchVue
            :key="componentKey"
            @changeSwitch="changeSwitch"
            class="mx-1 pl-2 pt-2"
            :checked="type_of_field.state == 1 ? true : false"
            color="success"
            variant="opposite"
            shape="pill"
            v-bind="labelIcon"
          />
        </CCol>
      </CRow>
    </CModalForm>

    <!-- modal delete -->
    <cModalDelete
      :backdrop="true"
      :closeOnBackdrop="true"
      :size="'md'"
      :title="'Borrar Rol'"
      :show.sync="modal_delete.boo"
      @mtd_commit="mtd_commit"
      :centered="true"
      :item="modal_delete.item"
    />
  </div>
</template>

<script>
const fields = [
  { key: "index", label: "Id", _style: "width:1%" },
  { key: "name", label: "Nombre", _style: "width:20%;" },
  { key: "state", label: "Estado", _style: "width:5%;" },
];

import CTableWrapper from "../shared/datatable/Table.vue";
import CModalForm from "../shared/modals/cModalForm.vue";
import cModalDelete from "../shared/modals/cModalDelete.vue";
import { mapActions } from "vuex";
import { bus } from "../../main";
import { CSwitch } from "@coreui/vue-pro";
import CSwitchVue from "../shared/switch/CSwitch.vue";

export default {
  components: { CTableWrapper, CModalForm, cModalDelete, CSwitchVue },
  data() {
    return {
      prefix: "types_of_fields",
      fields,
      data: [],
      modal: {
        action: "",
        title: "",
        modal_form: false,
      },
      type_of_field: {
        id: "",
        name: "",
        company: this.$store.getters.get_company,
        state: 0,
      },
      modal_delete: {
        boo: false,
        item: [],
      },
      labelIcon: {
        labelOn: "\u2713",
        labelOff: "\u2715",
      },
      componentKey: 0,
      // dataStore: [],
    };
  },
  computed: {
    cpStatus: function () {
      if (this.type_of_field.state == 1) return true;
      return false;
    },
    cp_button: function () {
      if (this.type_of_field.name != "") return false;
      return true;
    },
  },
  created() {
    this.mtd_getdata();
  },
  methods: {
    ...mapActions(["get", "post"]),
    // mtd_getdata: function () {
    //   this.get({
    //     url: this.$store.getters.get__url + "/" + this.prefix,
    //     token: this.$store.getters.get__token,
    //   })
    //     .then((response) => {
    //       this.data = response.data.types_of_fields;
    //       let index = 1;
    //       this.data.forEach((arr)=>{
    //         arr.index = index;
    //         index++;
    //       })
    //     })
    //     .catch((errors) => {
    //       // this.errorsBackend = errors;
    //       // this.$emit("error", this.event);
    //     });
    // },
    
    mtd_getdata: function () {
      this.get({
        url: this.$store.getters.get__url + "/" + this.prefix +"/index/"+ this.$store.getters.get_all_user.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.data = response.data.sports;
          let index = 1;
          this.data.forEach((arr)=>{
            arr.index = index;
            index++;
          })
        })
        .catch((errors) => {
          // this.errorsBackend = errors;
          // this.$emit("error", this.event);
        });
    },
    mtdBack: function () {
      this.$emit("mtdBack");
    },
    mtd_open_modal: function (boo, action) {
      this.modal.modal_form = boo;
      this.modal.action = action;
      action == "store"
        ? (this.modal.title = "Nuevo Tipo de campo")
        : (this.modal.title = "Editar Tipo de campo");
      action == "store"
        ? (this.type_of_field = {
            id: "",
            name: "",
            // company: this.$store.getters.get_company,
            state: "",
          })
        : (this.type_of_field = {...this.type_of_field});
      if (this.modal.action != "store") {
        this.componentKey += 1;
      }
    },
    mtd_action: function () {
      this.post({
        url:
          this.$store.getters.get__url +
          "/" +
          this.prefix +
          "/" +
          this.modal.action,
        token: this.$store.getters.get__token,
        params: this.type_of_field,
      })
        .then((response) => {
          if(response.data.state==1){
              Swal.fire({
                      title: "Tipo de campo ya resgistrado",
                      icon: "warning"
              });
          }else{
            let color = "success";
            let message = "";
            if (this.modal.action == "store") {
              message = "REGISTRADO CORRECTAMENTE";
              this.mtd_getdata();
            } else {
              let updatedType_of_field = response.data.data;
              let index = this.data.findIndex(type_of_field => type_of_field.id === updatedType_of_field.id);
              if (index !== -1) {
                this.$set(this.data, index, updatedType_of_field);
              }
              message = "EDITADO CORRECTAMENTE";
              this.mtd_getdata();
            }
            this.modal = {
              action: "",
              title: "",
              modal_form: false,
              name: "",
            };
            this.type_of_field = { id: "", name: "", state: 0 }; 

            bus.$emit("alert", {
              color: color,
              message: message,
            });
          }
        })
        .catch((errors) => {
          bus.$emit("alert", {
            color: "danger",
            message: errors,
          });
        });
    },
    mtd_show: function (id) {
      this.get({
        url:
          this.$store.getters.get__url + "/" + this.prefix + "/" + id + "/show",
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.type_of_field = response;
          this.mtd_open_modal(true, "update");
        })
        .catch((errors) => {});
    },
    mtd_delete: function (item) {
      this.modal_delete.boo = true;
      this.modal_delete.item = item;
    },
    close_delete: function () {
      this.modal_delete.boo = false;
    },
    mtd_commit: function () {
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/destroy",
        token: this.$store.getters.get__token,
        params: {
          id: this.modal_delete.item.id,
        },
      })
        .then((response) => {
          // let temp = [];
          // this.data.forEach((element) => {
          //   if (element.id != response.data.id) {
          //     temp.push(element);
          //   }
          // });
          // this.data = temp;
          // this.modal_delete = {
          //   boo: false,
          //   item: [],
          // };

          // bus.$emit("alert", {
          //   color: "success",
          //   message: "ELIMINADO CORRECTAMENTE",
          // });
          this.mtd_getdata();
          this.modal_delete = {
            boo: false,
            item: [],
          };

          bus.$emit("alert", {
            color: "success",
            message: "ELIMINADO CORRECTAMENTE",
          });
        })
        .catch((errors) => {});
    },
    changeSwitch: function (payload) {
      this.type_of_field.state = payload == true ? 1 : 0;
    },
  },
  destroyed() {
    // console.log(this.dataStore);
    // this.$store.commit("mt_set_datacampus", this.dataStore);
  },
};
</script>

<style lang="scss" scoped>
.btn-search {
  color: #fff;
  background-color: #2819ae;
  border-color: #2517a3;
}
</style>
